import { homepageBannerSideBarNav } from "./CHILDREN-SIDEBARNAV";

export default [
    {
        _name: 'CSidebarNav',
        _children: [
            {
                _name: 'CSidebarNavItem',
                name: 'Dashboard',
                to: '/dashboard',
                icon: 'cil-speedometer',
                badge: {
                    color: 'primary',
                    text: 'NEW'
                }
            },
            {
                _name: 'CSidebarNavTitle',
                _children: ['Feature']
            },
            homepageBannerSideBarNav,
            {
                _name: "CSidebarNavItem",
                name: "Routes",
                to: "/management/routes",
                icon: "cil-map"
            },
            {
                _name: "CSidebarNavItem",
                name: "Industry",
                to: "/management/industry",
                icon: "cil-industry"
            },
            {
                _name: "CSidebarNavItem",
                name: "Shortlink",
                to: "/management/shortlink",
                icon: "cil-link"
            },
            {
                _name: "CSidebarNavItem",
                name: "Banner List",
                to: "/management/banner-list",
                icon: "cil-laptop"
            },
            {
                _name: "CSidebarNavItem",
                name: "Meta Info",
                to: "/management/meta-info",
                icon: "cil-globe-alt"
            },
            {
                _name: "CSidebarNavItem",
                name: "Program",
                to: "/management/program",
                icon: "cil-layers"
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "Event & Tips",
                to: "/management/corporate",
                icon: 'cil-file',
                items: [
                    {
                        name: 'Event & Tips',
                        to: "/management/corporate",
                    },
                    {
                        name: 'Podcast',
                        to: '/management/corporate-podcast'
                    },
                    {
                        name: 'Hashtag',
                        to: '/management/corporate-hashtag'
                    },
                    {
                        name: 'Category',
                        to: '/management/corporate-category'
                    },
                    {
                        name: 'Author',
                        to: "/management/corporate-author",
                    },
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'About Us',
                route: '/about-us',
                icon: 'cil-puzzle',
                items: [
                    {
                        name: 'Press Release',
                        to: '/about-us/press-release'
                    },
                ]
            },
            {
                _name: "CSidebarNavItem",
                name: "Product",
                to: "/management/product",
                icon: "cil-grid"
            },
            {
                _name: "CSidebarNavItem",
                name: "Aggregator",
                to: "/management/aggregator",
                icon: "cil-justify-center"
            },
        ]
    }
]
